import { useState, useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { useRecoilState } from 'recoil';

export function useInput(
  initialValue: any,
): [any, (e: any) => void, () => void, any] {
  const [value, setValue] = useState(initialValue);

  useLayoutEffect(() => {
    if (initialValue) setValue(initialValue);
  }, [initialValue]);

  const handleChange = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  const reset = useCallback(() => setValue(initialValue || ''), [initialValue]);

  return [value, handleChange, reset, setValue];
}

export function useInputs(initialForm: any) {
  const [form, setForm] = useState(initialForm);

  // change
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((form) => ({ ...form, [name]: value }));
  }, []);

  // 🔧 개별 필드 업데이트 함수 추가
  const setFieldValue = useCallback((fieldName: string, value: any) => {
    setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
  }, []);

  const reset = useCallback(() => setForm(initialForm), [initialForm]);

  return [form, handleChange, reset, setForm, setFieldValue];
}

export function useRecoilInput(initialValue: any, atomState: any) {
  const [value, setValue] = useRecoilState<any>(atomState);

  const handleChange = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  const reset = useCallback(() => setValue(initialValue), [initialValue]);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return [value, handleChange, reset];
}

export function useRecoilInputs(initialForm: any, atomState: any) {
  const [form, setForm] = useRecoilState<any>(atomState);
  const isInitializedRef = useRef(false);

  // 🔧 최초 마운트 시에만 initialForm 적용
  useLayoutEffect(() => {
    if (!isInitializedRef.current && initialForm) {
      setForm(initialForm);
      isInitializedRef.current = true;
    }
  }, []); // 빈 의존성 배열로 최초 1회만 실행

  // change
  const handleChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      setForm((form) => ({ ...form, [name]: value }));
    },
    [],
  );

  const reset = useCallback(() => {
    setForm(initialForm);
  }, [initialForm]);

  // 🔧 개별 필드 업데이트 함수 추가
  const setFieldValue = useCallback((fieldName: string, value: any) => {
    setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
  }, []);

  return [form, handleChange, reset, setForm, setFieldValue];
}
